import { useState } from 'react';
import { GlobalSearchProps } from './GlobalSearch.types';
import { ArrowRight, Search, X } from '../icons';
import { TextField } from '../inputs/TextField';

export type { GlobalSearchProps } from './GlobalSearch.types';

export const GlobalSearch = ({
  initialValue = '',
  onSubmit = () => {},
  backgroundVariant = 'light',
  disabled,
  ...rest
}: GlobalSearchProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState<string>(initialValue);

  const isLight = value || isFocused || backgroundVariant === 'light';

  return (
    <form
      role="search"
      aria-label="Global"
      className={disabled ? 'pointer-events-none opacity-85' : undefined}
    >
      <div className="flex h-10 items-center gap-2">
        <TextField
          startContent={
            <Search
              role="img"
              aria-label="Global Search"
              size="2rem"
              className="fill-none stroke-primary-400"
            >
              <title>Global Search</title>
            </Search>
          }
          endContent={
            value ? (
              <X
                role="img"
                aria-label="Clean Global Search"
                size="2rem"
                className="cursor-pointer !text-secondary-900 hover:rounded-sm hover:bg-error-100 hover:!text-secondary-100 hover:shadow-primary-inset"
                onClick={() => {
                  setValue('');
                  onSubmit({ action: 'clear', value: '' });
                }}
              >
                <title>Clean Global Search</title>
              </X>
            ) : undefined
          }
          classNames={{
            input: [
              '!w-[30rem] !h-10 !text-h4 placeholder:!opacity-100',
              isLight ? 'placeholder:!text-secondary-700' : 'placeholder:!text-common-white',
            ].join(' '),
            inputContainer: [
              '!bg-secondary-100',
              isLight ? '!shadow-secondary-outset' : '!shadow-primary-inset',
            ].join(' '),
          }}
          placeholder="SEARCH"
          value={value}
          onChange={({ target }) => setValue(target.value)}
          onKeyDown={(e) => {
            if (e.key !== 'Enter') return;
            e.stopPropagation();
            e.preventDefault();
            setValue(value.trim());
            onSubmit({ action: 'submit', value: value.trim() });
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...rest}
        />
        <ArrowRight
          role="img"
          aria-label="Submit Global Search"
          size="2rem"
          className={[
            'size-9 cursor-pointer rounded-sm stroke-[3] p-2 !text-bg-secondary',
            '!shadow-(--confirm-button-shadow)',
            'hover:bg-bg-secondary hover:!text-bg-primary',
          ].join(' ')}
          onClick={() => onSubmit({ action: 'submit', value: value.trim() })}
        >
          <title>Submit Global Search</title>
        </ArrowRight>
      </div>
    </form>
  );
};
